<template>
    <div class="menu-body">
        <header class="app-header">
            <div class="header-inner">

                <div class="brand">
                    <a href="/">
                        <img v-bind:src="`${baseUrl}assets/image/esomobay.png`" alt="E-SOMOBAY">
                    </a>
                </div>

                <button class="nav-toggle" id="navToggle" aria-label="Open menu" aria-expanded="false">
                    <i class="fas fa-bars"></i>
                </button>

                <a class="header-call" href="tel:+8801710636667" aria-label="Call us">
                    <i class="fas fa-phone"></i>
                </a>

                <nav class="primary-nav" id="primaryNav">

                    <div class="mobile-nav-head">
                        <img v-bind:src="`${baseUrl}assets/image/esomobay.png`" alt="E-SOMOBAY">
                        <button class="mobile-close" id="navClose" aria-label="Close menu"><i class="fas fa-xmark"></i></button>
                    </div>

                    <ul class="nav-list">

                        <li class="nav-item">
                            <router-link to="/" class="nav-link router-active"><span>ড্যাশবোর্ড</span></router-link>
                        </li>

                        <li v-if="accessTypes.includes('2') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>সদস্য</span><i class="fas fa-chevron-down chev"></i></a>
                            <ul class="dropdown">
                                <li v-if="accessModules.includes('4') || parseInt(accessRole) === 1"><router-link to="/member/create"><i class="fas fa-user-plus"></i>সদস্য ভর্তি</router-link></li>
                                <li v-if="accessModules.includes('5') || parseInt(accessRole) === 1"><router-link to="/member/lists"><i class="fas fa-users"></i>সদস্য তালিকা</router-link></li>
                                <li v-if="accessModules.includes('97') || parseInt(accessRole) === 1"><router-link to="/documents/member"><i class="fa-solid fa-id-card-clip"></i>সদস্যর ডকুমেন্টস</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('3') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>লেনদেন</span><i class="fas fa-chevron-down chev"></i></a>
                            <div class="mega">
                                <div class="mega-grid">
                                    <div class="mega-col">
                                        <div class="mega-heading">শেয়ার</div>
                                        <router-link v-if="accessModules.includes('8') || parseInt(accessRole) === 1" to="/share/collection">শেয়ার গ্রহণ</router-link>
                                        <router-link v-if="accessModules.includes('9') || parseInt(accessRole) === 1" to="/share/withdraw">শেয়ার উত্তোলন</router-link>
                                        <div class="mega-heading">মেয়াদী আমানত</div>
                                        <router-link v-if="accessModules.includes('17') || parseInt(accessRole) === 1" to="/fdr/collection">মেয়াদী আমানত গ্রহণ</router-link>
                                        <router-link v-if="accessModules.includes('18') || parseInt(accessRole) === 1" to="/fdr/withdraw">মেয়াদী আমানত উত্তোলন</router-link>
                                        <div class="mega-heading">সঞ্চয় আমানত</div>
                                        <router-link v-if="accessModules.includes('21') || parseInt(accessRole) === 1" to="/saving/collection">সঞ্চয় আমানত গ্রহণ</router-link>
                                        <router-link v-if="accessModules.includes('22') || parseInt(accessRole) === 1" to="/saving/withdraw">সঞ্চয় আমানত উত্তোলন</router-link>
                                    </div>
                                    <div class="mega-col">
                                        <div class="mega-heading">ঋণ / বিনিয়োগ</div>
                                        <router-link v-if="accessModules.includes('12') || parseInt(accessRole) === 1" to="/loan/create">ঋণ প্রদান</router-link>
                                        <router-link v-if="accessModules.includes('13') || parseInt(accessRole) === 1" to="/installment/create">ঋণের কিস্তি আদায়</router-link>
                                        <div class="mega-heading">হাওলাত</div>
                                        <router-link v-if="accessModules.includes('25') || parseInt(accessRole) === 1" to="/borrow/collection">হাওলাত গ্রহণ</router-link>
                                        <router-link v-if="accessModules.includes('26') || parseInt(accessRole) === 1" to="/borrow/withdraw">হাওলাত ফেরত</router-link>
                                        <div class="mega-heading">অন্যান্য</div>
                                        <router-link v-if="accessModules.includes('29') || parseInt(accessRole) === 1" to="/salary/create">বেতন-ভাতাদি প্রদান</router-link>
                                        <router-link v-if="accessModules.includes('31') || parseInt(accessRole) === 1" to="/particular-transaction/create">অন্যান্য লেনদেন</router-link>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="accessTypes.includes('4') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>লেনদেনের তালিকা</span><i class="fas fa-chevron-down chev"></i></a>
                            <div class="mega">
                                <div class="mega-grid">
                                    <div class="mega-col">
                                        <div class="mega-heading">শেয়ার</div>
                                        <router-link v-if="accessModules.includes('10') || parseInt(accessRole) === 1" to="/share/lists">শেয়ারের তালিকা</router-link>
                                        <div class="mega-heading">মেয়াদী আমানত</div>
                                        <router-link v-if="accessModules.includes('19') || parseInt(accessRole) === 1" to="/fdr/lists">মেয়াদী আমানতের তালিকা</router-link>
                                        <div class="mega-heading">সঞ্চয় আমানত</div>
                                        <router-link v-if="accessModules.includes('23') || parseInt(accessRole) === 1" to="/saving/lists">সঞ্চয় আমানতের তালিকা</router-link>
                                    </div>
                                    <div class="mega-col">
                                        <div class="mega-heading">ঋণ / বিনিয়োগ</div>
                                        <router-link v-if="accessModules.includes('14') || parseInt(accessRole) === 1" to="/loan/lists">ঋণের তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('84') || parseInt(accessRole) === 1" to="/installment/lists">কিস্তির তালিকা</router-link>
                                        <div class="mega-heading">হাওলাত</div>
                                        <router-link v-if="accessModules.includes('27') || parseInt(accessRole) === 1" to="/borrow/lists">হাওলাতের তালিকা</router-link>
                                        <div class="mega-heading">অন্যান্য</div>
                                        <router-link v-if="accessModules.includes('30') || parseInt(accessRole) === 1" to="/salary/lists">বেতন-ভাতাদির তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('32') || parseInt(accessRole) === 1" to="/particular-transaction/lists">অন্যান্য লেনদেনের তালিকা</router-link>
                                    </div>
                                </div>
                            </div>
                        </li>

                        <li v-if="accessModules.includes('91') || accessModules.includes('92') || accessModules.includes('93') || accessModules.includes('94') || accessModules.includes('95') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>চলমান লেনদেন</span><i class="fas fa-chevron-down chev"></i></a>
                            <ul class="dropdown">
                                <li v-if="accessModules.includes('91') || parseInt(accessRole) === 1"><router-link to="/share/members"><i class="fas fa-chart-pie"></i>শেয়ারের তালিকা</router-link></li>
                                <li v-if="accessModules.includes('92') || parseInt(accessRole) === 1"><router-link to="/saving/members"><i class="fas fa-piggy-bank"></i>সঞ্চয়ের তালিকা</router-link></li>
                                <li v-if="accessModules.includes('93') || parseInt(accessRole) === 1"><router-link to="/loan/members"><i class="fas fa-hand-holding-dollar"></i>ঋণের তালিকা</router-link></li>
                                <li v-if="accessModules.includes('94') || parseInt(accessRole) === 1"><router-link to="/fdr/members"><i class="fas fa-vault"></i>মেয়াদী আমানতের তালিকা</router-link></li>
                                <li v-if="accessModules.includes('95') || parseInt(accessRole) === 1"><router-link to="/borrow/members"><i class="fas fa-rotate"></i>হাওলাতের তালিকা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('6') || accessTypes.includes('7') || parseInt(accessRole) === 1" class="nav-item">
                            <router-link to="/reports" class="nav-link"><span>রিপোর্ট</span></router-link>
                        </li>

                        <li v-if="accessTypes.includes('5') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>আদায় ফর্ম</span><i class="fas fa-chevron-down chev"></i></a>
                            <ul class="dropdown">
                                <li v-if="accessModules.includes('34') || parseInt(accessRole) === 1"><router-link to="/collection/regular-installment"><i class="fas fa-receipt"></i>নিয়মিত কিস্তি আদায়</router-link></li>
                                <li v-if="accessModules.includes('35') || parseInt(accessRole) === 1"><router-link to="/collection/expired-loan-installment"><i class="fas fa-triangle-exclamation"></i>মেয়াদউত্তীর্ণ ঋণের কিস্তি আদায়</router-link></li>
                                <li v-if="accessModules.includes('36') || parseInt(accessRole) === 1"><router-link to="/collection/regular-saving"><i class="fas fa-coins"></i>নিয়মিত সঞ্চয় আদায়</router-link></li>
                                <li v-if="accessModules.includes('37') || parseInt(accessRole) === 1"><router-link to="/collection/weekly-monthly-savings"><i class="fas fa-folder-open"></i>সাপ্তাহিক ও মাসিক সঞ্চয় আদায়</router-link></li>
                                <li v-if="accessModules.includes('83') || parseInt(accessRole) === 1"><router-link to="/collection/weekly-monthly-savings-installments"><i class="fas fa-calendar-days"></i>সাপ্তাহিক-মাসিক সঞ্চয় ও কিস্তি</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('8') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>এসএমএস</span><i class="fas fa-chevron-down chev"></i></a>
                            <ul class="dropdown">
                                <li v-if="accessModules.includes('50') || parseInt(accessRole) === 1"><router-link to="/sms/new"><i class="fas fa-paper-plane"></i>নতুন এসএমএস</router-link></li>
                                <li v-if="accessModules.includes('51') || parseInt(accessRole) === 1"><router-link to="/sms/lists"><i class="fas fa-comments"></i>এসএমএস তালিকা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('9') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>অ্যাডমিন</span><i class="fas fa-chevron-down chev"></i></a>
                            <ul class="dropdown">
                                <li v-if="accessModules.includes('54') || parseInt(accessRole) === 1"><router-link to="/admin/lists"><i class="fas fa-user-shield"></i>অ্যাডমিন তালিকা</router-link></li>
                                <li v-if="accessModules.includes('57') || parseInt(accessRole) === 1"><router-link to="/admin/permission"><i class="fas fa-key"></i>অ্যাডমিন কার্যক্ষমতা</router-link></li>
                            </ul>
                        </li>

                        <li v-if="accessTypes.includes('10') || parseInt(accessRole) === 1" class="nav-item">
                            <a href="javascript:void(0)" class="nav-link"><span>সেটিংস</span><i class="fas fa-chevron-down chev"></i></a>
                            <div class="mega">
                                <div class="mega-grid">
                                    <div class="mega-col">
                                        <div class="mega-heading">সাধারণ সেটিংস</div>
                                        <router-link v-if="accessModules.includes('68') || parseInt(accessRole) === 1" to="/group/lists">সদস্য গ্রুপের তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('71') || parseInt(accessRole) === 1" to="/center/lists">সদস্য কেন্দ্রের তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('60') || parseInt(accessRole) === 1" to="/audit/lists">অডিট/নিরীক্ষার তথ্যাদি</router-link>
                                        <router-link v-if="accessModules.includes('63') || parseInt(accessRole) === 1" to="/holidays/lists">ছুটির তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('65') || parseInt(accessRole) === 1" to="/particular/lists">লেনদেনের খাতের তালিকা</router-link>
                                    </div>
                                    <div class="mega-col">
                                        <div class="mega-heading">সফটওয়্যার সেটিংস</div>
                                        <router-link v-if="accessModules.includes('74') || parseInt(accessRole) === 1" to="/event/lists">সভা/বৈঠকের তালিকা</router-link>
                                        <router-link v-if="accessModules.includes('77') || parseInt(accessRole) === 1" to="/committee/lists">ব্যবস্থাপনা কমিটি</router-link>
                                        <router-link v-if="accessModules.includes('80') || parseInt(accessRole) === 1" to="/notice/lists">নোটিশ বোর্ড</router-link>
                                        <router-link v-if="accessModules.includes('81') || parseInt(accessRole) === 1" to="/settings/view">সফটওয়্যার সেটিংস</router-link>
                                        <a href="https://wa.me/+8801710636667" target="_blank">যোগাযোগ</a>
                                    </div>
                                </div>
                            </div>
                        </li>

                    </ul>

                    <div class="nav-item nav-user" id="navUser">
                        <a href="javascript:void(0)" class="nav-link">
                            <img v-bind:src="`${IMAGEURL+adminImage}`" alt="Profile" class="avatar">
                            <span class="account-name"><span>{{configData?.adminName}}</span><small>{{configData?.adminDesignation}}</small></span>
                            <i class="fas fa-chevron-down chev"></i>
                        </a>
                        <ul class="dropdown">
                            <li><router-link to="/admin/profile"><i class="fas fa-user-tie"></i>আমার প্রোফাইল</router-link></li>
                            <li><router-link to="/admin/tasks"><i class="fas fa-list-check"></i>কার্যতালিকা</router-link></li>
                            <li><router-link to="/admin/profile"><i class="fas fa-lock"></i>পাসওয়ার্ড পরিবর্তন</router-link></li>
                            <li class="divider"></li>
                            <li class="logout"><a href="javascript:void(0)" @click="logout()"><i class="fas fa-right-from-bracket"></i>Logout</a></li>
                        </ul>
                    </div>

                </nav>
            </div>
        </header>

        <div class="nav-overlay" id="navOverlay"></div>

    </div>
</template>

<script>
    import Vue from 'vue'
    import {logoutFromApp, logoutFromBackend} from "../../services/auth";

    export default {
        name: 'Menu',
        components: {},
        data() {
            return {
                configData: JSON.parse(localStorage.getItem("users")),
                accessRole: JSON.parse(localStorage.getItem("users")).role,
                adminImage: JSON.parse(localStorage.getItem("users")).image,
                accessTypes: JSON.parse(localStorage.getItem("users")).accessTypesId,
                accessModules: JSON.parse(localStorage.getItem("users")).accessModulesId
            };
        },
        mounted() {
            let customJavaScript = document.createElement('script');
            customJavaScript.async = true;
            customJavaScript.setAttribute('src', this.baseUrl + 'assets/nav/menu.js');
            document.head.appendChild(customJavaScript);
        },
        methods: {
            logout() {

                overlayLoading(true);

                logoutFromBackend().then((response) => {
                    if (response.status) {
                        this.flashMessage.success({message: response.message});
                    } else {
                        this.flashMessage.error({message: response.message});
                    }
                }).catch((e) => {
                    this.flashMessage.error({message: e});
                });

                setTimeout(function () {
                    logoutFromApp();
                }, 1000);
            }
        }
    }
</script>

<style scoped>

</style>
